(function () {
  'use strict';

  // Zoomed-out enough to recognize the continent, centered on the growing region
  var ORIGINS = {
    ethiopia:     { lat:  8.0,   lng: 38.5,   zoom: 2 },
    yirgacheffe:  { lat:  6.5,   lng: 38.5,   zoom: 2 },
    guji:         { lat:  6.0,   lng: 38.5,   zoom: 2 },
    sidama:       { lat:  6.8,   lng: 38.4,   zoom: 2 },
    colombia:     { lat:  4.0,   lng: -73.0,  zoom: 2 },
    huila:        { lat:  2.0,   lng: -76.0,  zoom: 2 },
    'nariño':     { lat:  1.0,   lng: -77.5,  zoom: 2 },
    narino:       { lat:  1.0,   lng: -77.5,  zoom: 2 },
    guatemala:    { lat: 15.5,   lng: -90.5,  zoom: 3 },
    kenya:        { lat:  0.0,   lng: 37.5,   zoom: 2 },
    brazil:       { lat:-15.0,   lng: -50.0,  zoom: 2 },
    honduras:     { lat: 14.5,   lng: -86.5,  zoom: 3 },
    'costa rica': { lat:  9.7,   lng: -83.8,  zoom: 3 },
    nicaragua:    { lat: 12.8,   lng: -86.0,  zoom: 3 },
    mexico:       { lat: 16.0,   lng: -92.5,  zoom: 3 },
    peru:         { lat:-10.0,   lng: -74.0,  zoom: 2 },
    rwanda:       { lat: -2.0,   lng: 29.9,   zoom: 3 },
    burundi:      { lat: -3.4,   lng: 29.9,   zoom: 3 },
    tanzania:     { lat: -6.0,   lng: 35.0,   zoom: 2 },
    uganda:       { lat:  1.0,   lng: 32.5,   zoom: 2 },
    yemen:        { lat: 15.5,   lng: 46.0,   zoom: 3 },
    indonesia:    { lat: -5.0,   lng: 117.0,  zoom: 2 },
    sumatra:      { lat:  0.0,   lng: 101.5,  zoom: 3 },
    india:        { lat: 13.0,   lng: 75.5,   zoom: 3 },
    panama:       { lat:  8.5,   lng: -80.0,  zoom: 4 },
    'el salvador':{ lat: 13.7,   lng: -89.2,  zoom: 4 },
    bolivia:      { lat:-16.0,   lng: -67.0,  zoom: 2 },
    'timor-leste':{ lat: -8.9,   lng: 125.7,  zoom: 4 },
    timor:        { lat: -8.9,   lng: 125.7,  zoom: 4 },
    papua:        { lat: -6.0,   lng: 143.0,  zoom: 3 },
  };

  function resolveCoords(origin) {
    if (!origin) return null;
    var lower = String(origin).toLowerCase().replace(/[,·]/g, ' ');
    // Longest key first so "yirgacheffe" wins over "ethiopia"
    var keys = Object.keys(ORIGINS).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < keys.length; i++) {
      if (lower.indexOf(keys[i]) !== -1) {
        var c = ORIGINS[keys[i]];
        return { lat: c.lat, lng: c.lng, zoom: c.zoom, label: String(origin).split(',')[0].trim() };
      }
    }
    return null;
  }

  function initMap(el) {
    if (el.dataset.mapReady === '1') return;
    if (!window.L) return;

    var origin = el.getAttribute('data-origin') || '';
    var coords = resolveCoords(origin);
    if (!coords) return;

    var canvas = el.querySelector('[data-coffee-origin-map-canvas]');
    if (!canvas) return;

    el.dataset.mapReady = '1';

    var map = window.L.map(canvas, {
      scrollWheelZoom: false,
      zoomControl: false,
      attributionControl: false,
    }).setView([coords.lat, coords.lng], coords.zoom);

    // CARTO Voyager No-Labels — warm, clean, label-free
    window.L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}{r}.png', {
      maxZoom: 18,
      subdomains: 'abcd',
    }).addTo(map);

    // CircleMarker: pure SVG, no CSS/icon dependency, always renders
    window.L.circleMarker([coords.lat, coords.lng], {
      radius: 9,
      fillColor: '#2FA188',
      color: '#ffffff',
      weight: 2.5,
      opacity: 1,
      fillOpacity: 1,
    }).addTo(map);

    // Subtle zoom control
    window.L.control.zoom({ position: 'bottomright' }).addTo(map);

    // Ensure tiles render at correct size after layout settles
    [80, 250, 500].forEach(function (ms) {
      window.setTimeout(function () { map.invalidateSize(); }, ms);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-coffee-origin-map]').forEach(function (el) {
      if (el.dataset.mapReady === '1') return;

      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            initMap(el);
            obs.disconnect();
          });
        }, { root: null, rootMargin: '200px 0px', threshold: 0 });
        obs.observe(el);
      } else {
        initMap(el);
      }
    });
  }

  // 'load' fires after all defer scripts so window.L is guaranteed available
  if (document.readyState === 'complete') {
    initAll();
  } else {
    window.addEventListener('load', initAll);
  }
})();
